<template lang="pug">
  .cart-membership-program.xs-12.background-gray-light.xs-mt-100m(v-if="hasMembershipPricing && (!!potentialMembershipSavings || !!membershipSavings)")
    .logo
      .a-box-xs-12x5.xs-pl-100m
        .a-box-content
          ImgBox(:mediaId="settings.mediaId")

    .description.xs-text-center.sm-text-left
      p.xs-f-small.max-at-tweak(v-html="settings.description")

    button.transparent-btn#cart-membership-program-subscribe-and-save.membership-savings-display(v-if="!!potentialMembershipSavings" @click="editOneTimeProducts")
      span.refresh.icon-heart-refresh.color-purple.xs-f-grande.md-f-xgrande.lg-f-grande.max-at-tweak
        span.ada-tooltip heart refresh icon

      p#cart-membership-program-savings.color-purple.upper.semi-bold.xs-f-medium.max-at-tweak
        | Join now to&nbsp;save 
        span.color-black.bold {{potentialMembershipSavings | currency}}
        | &nbsp;&#9654;

    .membership-savings-display(v-else)
      span.refresh.icon-heart-refresh.color-purple.xs-f-grande.md-f-xgrande.lg-f-grande.max-at-tweak
        span.ada-tooltip heart refresh icon

      p#cart-membership-program-savings.color-purple.upper.semi-bold.xs-f-medium.max-at-tweak
        | You're saving 
        span.color-black.bold {{membershipSavings | currency}}

</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import ImgBox from '../../imgBox';

  export default {
    name: "CartMembershipProgram",

    data() {
      return {
        settings: {
          mediaId: 5065,
          description: 'Our <b>Membership program</b> gives you everything you want more of&mdash;more savings, more me-time, and more gorgeous hair days.',
        }
      }
    },

    components: {
      ImgBox
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('cart', ['cart']),
      ...mapGetters('customer', ['hasMembershipPricing']),
      
      potentialMembershipSavings() {
        return this.getObjProperty(this.cart, 'totals.potentialMembershipSavings');
      },

      membershipSavings() {
        return this.getObjProperty(this.cart, 'totals.membershipSavings');
      }
    },

    methods: {
      ...mapMutations('cart', ['setEditAllItems']),

      editOneTimeProducts() {
        this.setEditAllItems(true);
        this.trackEvent('Cart Auto Delivery Batch Edit');
      },
    },
   }

</script>

<style scoped lang="stylus">
  .cart-membership-program
    display flex
    flex-direction column
    justify-content flex-end
    align-items stretch
      
    .logo
      margin-top 1.5em
      text-align center

      .a-box-xs-12x5
        display inline-block
        width 14em
        vertical-align top

    .description
      display inline-block
      padding 1em 7%

    .membership-savings-display
      display flex
      flex-direction row
      justify-content center
      align-items center
      background-color rgba(color-mr-blue, 0.3)
      text-align center
      padding 15px 0
  
@media mq-tablet-plus
  .cart-membership-program
    flex-direction row
    flex-wrap wrap

    .logo 
      width 50%
      flex-grow 1
      .a-box-xs-12x5
        width 10em

    .description
      padding 1em 3%
      width 50%
      flex-grow 1
    
    .membership-savings-display
      padding 0 0
      flex-grow 2

@media mq-desktop-plus
  .cart-membership-program
    flex-wrap nowrap

    .logo
      width 25%

    .membership-savings-display
      flex-direction column

      #cart-membership-program-savings
        width 9em

@media mq-tablet
  .cart-membership-program  
    .logo
      .a-box-xs-12x5
        width 12em

    .description
      padding-left 0
      padding-right 5%

    .membership-savings-display
      height 3.5em

@media mq-desktop-md
  .cart-membership-program
    .logo
      .a-box-xs-12x5
        width 12em

    .description
      padding-left 0
      padding-right 12%

    .membership-savings-display
      height 3.5em

@media mq-mobile
  .cart-membership-program
    #cart-membership-program-savings
      width 9em

</style>